import "./bloggridcomponentmini.css"

import blogMeta from "../../../data/blogmeta";

import { useLocation } from "wouter";

export default function BlogGridComponentMini() {
  const [, navigate] = useLocation();
  return (
    <div>
      <div className="BlogGrid-Main">
        {blogMeta.slice(0, 3).map((blog, index) => (
            <div 
            key={blog.id} 
            onClick={() => navigate(`/blogs/${blog.id}`)} 
            className="BlogGrid">
              <div className="BlogGrid-Img-Wrapper">
                <a href="#" className="MicroLinkText">Know more</a>
                <img src={blog.image} alt="" />
              </div>
              <div className="BlogGrid-Details">
                <h3 className="">{blog.title}</h3>
                <p>{blog.description}</p>
              </div>
            </div>
        ))}
      </div>
    </div>
  );
}
